module.exports = __webpack_public_path__ + "images/72c8b00bb022275bfd67f6b47ec50cad.png";